import { Badge } from "@/components/ui/badge";

type Props = {
  dapOption: boolean;
};

export const Incoterm = ({ dapOption }: Props) => {
  if (dapOption) {
    return (
      <Badge variant="purple" className="border-0 uppercase">
        DAP
      </Badge>
    );
  }
  return (
    <Badge variant="gray" className="border-0 uppercase">
      DDP
    </Badge>
  );
};
